// frontend/src/pages/write/writeHelpers.js

// Small date formatting helper
export const fmtTs = (ts) =>
  ts ? new Date(ts).toLocaleString() : "";

// Compute final draft due date based on est. word count and createdAt
export const computeFinalDraftDue = (count, createdAt) => {
  if (!count || typeof count !== "string") return null;

  // Map each range to the number of days allowed
  const rangeToDays = {
    "500-999": 22,
    "1000-1499": 24,
    "1500-1999": 26,
    "2000-2499": 28,
    "2500+": 30,
  };

  // Get the matching days, or default to 7 if unrecognized
  const addDays = rangeToDays[count] || 7;
  const base = createdAt ? new Date(createdAt) : new Date();

  const due = new Date(base);
  due.setDate(base.getDate() + addDays);
  due.setHours(17, 0, 0, 0); // set to 5:00 PM local time

  return due.toISOString();
};

// Choose the best slug from multiple possible fields on a draft/article
export const pickSlug = (d) =>
  d?.post_slug ??
  d?.postSlug ??
  d?.draftSlug ??
  d?.slug ??
  d?.tempSlug ??
  null;

// Normalize featured image structure from either new or legacy post shape
export const normalizeFeaturedImageFromPost = (p) => {
  if (!p) return null;

  const fi = p.featuredImage || {};
  const src = fi.src ?? p.photo ?? "";

  if (!src) return null;

  return {
    src,
    alt: fi.alt ?? p.photoAlt ?? "",
    attribution: fi.attribution ?? p.photoAttribution ?? "",
    caption: fi.caption ?? p.photoCaption ?? "",
    variants: fi.variants ?? p.photoVariants ?? [],
    filenameBase: fi.filenameBase ?? p.filenameBase ?? "",
  };
};

// Build the featured image payload for the backend from a normalized object
export const getFeaturedImagePayload = (featuredImageData) => {
  if (!featuredImageData?.src) return null;

  const payload = {
    featuredImage: {
      src: featuredImageData.src,
      alt: (featuredImageData.alt || "").trim(),
      attribution: (featuredImageData.attribution || "").trim(),
      caption: (featuredImageData.caption || "").trim(),
      variants: Array.isArray(featuredImageData.variants) ? featuredImageData.variants : [],
      filenameBase: featuredImageData.filenameBase || "",
    },
  };

  // Optional: keep legacy fields in sync during migration (safe to remove later)
  payload.photo = featuredImageData.src;
  payload.photoCaption = (featuredImageData.caption || "").trim();

  return payload;
};
